import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStorefrontBrandName, getStorefrontLogoUrl } from '../../utils/storefrontBrand';

const FALLBACK_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/temizlik-store-logo.svg`;

const sizeMap = {
  sm: 36,
  md: 48,
  lg: 58
};

const StorefrontLogo = ({
  company,
  size = 'md',
  showWordmark = false,
  wordmarkClassName = '',
  tagline,
  theme = 'light',
  variant = 'default'
}) => {
  const { t } = useTranslation();
  const brandName = getStorefrontBrandName(t, company);
  const logoSrc = getStorefrontLogoUrl(company) || FALLBACK_LOGO_SRC;
  const dimension = typeof size === 'number' ? size : sizeMap[size] || sizeMap.md;

  const titleClass =
    theme === 'dark'
      ? 'text-white font-bold text-base leading-tight'
      : 'text-gray-900 font-extrabold text-lg sm:text-xl leading-tight tracking-tight';

  const subtitleClass =
    theme === 'dark'
      ? 'text-xs text-gray-400'
      : 'text-[11px] sm:text-xs text-blue-600 font-medium';

  const handleLogoError = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = FALLBACK_LOGO_SRC;
  };

  if (variant === 'header') {
    return (
      <div className={`flex flex-col justify-center min-w-0 ${wordmarkClassName}`}>
        <div className="h-10 sm:h-11 lg:h-12 xl:h-14 w-[clamp(7.5rem,28vw,17rem)] max-w-full">
          <img
            src={logoSrc}
            alt={brandName}
            className="h-full w-full object-contain object-left"
            onError={handleLogoError}
          />
        </div>
        {tagline && (
          <span className={`block mt-0.5 truncate leading-tight max-w-[clamp(7.5rem,28vw,17rem)] ${subtitleClass}`}>
            {tagline}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 min-w-0 ${wordmarkClassName}`}>
      <img
        src={logoSrc}
        alt={brandName}
        width={dimension}
        height={dimension}
        className="flex-shrink-0 rounded-2xl object-contain shadow-sm border border-gray-100 bg-white"
        onError={handleLogoError}
      />
      {showWordmark && (
        <div className="min-w-0 hidden sm:block">
          <span className={`block truncate ${titleClass}`}>{brandName}</span>
          {tagline && <span className={`block truncate hidden sm:block ${subtitleClass}`}>{tagline}</span>}
        </div>
      )}
    </div>
  );
};

export default StorefrontLogo;
